import { useAuthStore } from 'shared/store/authStore'
import AddCompanyForm from './AddCompanyForm'
import UnifiedRegisterForm from './UnifiedRegisterForm'

export interface CompanyRegisterModalContentProps {
  onClose?: () => void
  onOpenLogin?: () => void
  onSuccess?: () => void
}

/**
 * Content for company registration modal.
 * - Logged in: only company fields (AddCompanyForm), no email/password.
 * - Not logged in: full registration with email, password, company (UnifiedRegisterForm).
 */
export default function CompanyRegisterModalContent({
  onClose,
  onOpenLogin,
  onSuccess,
}: CompanyRegisterModalContentProps) {
  const customer = useAuthStore((s) => s.customer)
  const me = useAuthStore((s) => s.me)
  const isLoggedIn = !!customer?.token && !!customer?.user

  if (isLoggedIn && !me?.has_company) {
    return (
      <AddCompanyForm
        embedded
        onClose={onClose}
        onSuccess={onSuccess}
      />
    )
  }

  return (
    <UnifiedRegisterForm
      embedded
      defaultRegisterAsCompany
      onClose={onClose}
      onOpenLogin={onOpenLogin}
    />
  )
}
